<div class="chart-plotter" [ngClass]="{
  'revision-chart': isRevisionChart
}">
  <nz-spin
    nzTip="Crunching numbers..."
    *ngIf="
      !chartReady &&
      chartType !== 'mini-distribution-chart' &&
      chartType !== 'mini-revision-chart' &&
      chartType !== 'mini-trend-chart'
    "
    class="spinner"
  >
  </nz-spin>
  <highcharts-chart
    *ngIf="chartReady && !showError"
    [Highcharts]="highcharts"
    [options]="chartOptions"
    [(update)]="updateFlag"
    (chartInstance)="logChartInstance($event)"
    style="width: 100%; height: 100%;display: block;"
    
  >
  </highcharts-chart>
  <div
    class="data-point-legends"
    *ngIf="
      chartReady &&
      !showError &&
      (chartType === 'revision-daily' || chartType === 'revision-monthly')
    "
  >
    <span class="earnings-color"></span><span>Earnings</span>
    <span class="revisions-color"></span><span>Revision Dates</span>
  </div>
  <div id="charts-error" class="error-container" *ngIf="showError">
    <div class="error-msg">
      <va-icon name="info-circle" class="info-icon"></va-icon>
      <span class="error-text">{{
        errorMessage ? errorMessage : "Something went wrong"
      }}</span>
    </div>
  </div>
</div>
